var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "w-full h-full absolute inset-0",
      attrs: { "data-grm-comp": "GrmDraggableResizable" },
    },
    [
      _c(
        "vue-draggable-resizable",
        {
          staticClass: "top-0 left-0",
          staticStyle: { "pointer-events": "auto" },
          attrs: {
            w: _vm.w,
            h: _vm.h,
            x: _vm.x,
            y: _vm.y,
            z: _vm.z,
            "min-width": _vm.minWidth,
            "max-width": _vm.maxWidth,
            "min-height": _vm.minHeight,
            "max-height": _vm.maxHeight,
            lockAspectRatio: _vm.lockAspectRatio,
            parent: _vm.parent,
            onResize: _vm.onResize,
            onDrag: _vm.onDrag,
          },
        },
        [_vm._t("default")],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }